// Set to a number to force a fixed offset (minutes east of UTC), e.g. 180 for +03:00.
// Leave as null to use the device's local offset.
const FIXED_TZ_MINUTES: number | null = null;

const pad = (n: number) => String(n).padStart(2, '0');

export function coerceDate(input: unknown): Date | null {
    if (input == null) return null;
    if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
    if (typeof input === 'number') {
        const d = new Date(input);
        return isNaN(d.getTime()) ? null : d;
    }
    if (typeof input === 'string') {
        const s = input.trim();
        if (!s) return null;
        const d = new Date(s);
        return isNaN(d.getTime()) ? null : d;
    }
    return null;
}

export function looksLikeIso(s: string): boolean {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(
        s
    );
}

/** Backend needs: YYYY-MM-DDTHH:mm:ss±HH:mm */
export function toBackendOffsetString(input: unknown): string | null {
    const d = coerceDate(input);
    if (!d) return null;

    const yyyy = d.getFullYear();
    const MM = pad(d.getMonth() + 1);
    const DD = pad(d.getDate());
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const ss = pad(d.getSeconds());

    const tzMinutes = FIXED_TZ_MINUTES ?? -d.getTimezoneOffset(); // minutes east of UTC
    const sign = tzMinutes >= 0 ? '+' : '-';
    const abs = Math.abs(tzMinutes);
    const tzh = pad(Math.floor(abs / 60));
    const tzm = pad(abs % 60);

    return `${yyyy}-${MM}-${DD}T${hh}:${mm}:${ss}${sign}${tzh}:${tzm}`;
}

/** Optional for tables/text (kept from your current pipe) */
// export function formatUiDate(input: unknown): string | null {
//     const d = coerceDate(input);
//     if (!d) return null;
//     return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
// }

export function formatUiDate(input: unknown): string | null {
    const d = coerceDate(input);
    if (!d) return null;
    // MM/DD/YYYY
    return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
}
